import { useEffect } from 'react';

import { ClickTarget, click } from '@tracking';

const useAnalyticsWrapper = ({ shouldTrackClick, trackEvent }) => {
  useEffect(() => {
    let eventTracker;

    if (shouldTrackClick) {
      eventTracker = (event) => {
        const target = event.target as HTMLElement;
        const anchorLink = target.closest('a');
        const button = target.closest('button');
        const text = target.innerText;
        if (anchorLink || button) {
          trackEvent(
            click({
              clickTarget: anchorLink ? ClickTarget.AnchorLink : ClickTarget.Button,
              clickText: text,
            })
          );
        }
      };
      document.addEventListener('click', eventTracker, { passive: true });
    }

    return () => {
      if (eventTracker) {
        document.removeEventListener('click', eventTracker, {
          passive: true,
        } as EventListenerOptions);
      }
    };
  }, [shouldTrackClick, trackEvent]);
};

export default useAnalyticsWrapper;
